<template lang="pug">
.app-excerpt
  .app-excerpt__container(
    :class="expandedClass"
    role="content"
    :style="containerStyle"
  )
    .app-excerpt__slot(ref="slotWrapper")
      slot
  a.app-excerpt__trigger(
    v-if="showMoreButton"
    href="#"
    @click.prevent="toggleExpanded"
  )
    template(v-if="!expanded") {{ showMoreText }}
    template(v-else) {{ showLessText }}
</template>

<script>
export default {
  name: 'AppExcerpt',
  props: {
    collapseHeight: {
      type: Number,
      // Roughly 5 lines of text
      default: 120,
    },
    defaultExpanded: {
      type: Boolean,
      default: false,
    },
    showMoreText: {
      type: String,
      default: 'Show more',
    },
    showLessText: {
      type: String,
      default: 'Show less',
    },
  },
  data() {
    return {
      originalHeight: null,
      expanded: this.defaultExpanded,
    };
  },
  computed: {
    expandedClass() {
      return {
        'app-excerpt__container--expanded': this.expanded,
        'app-excerpt__container--disabled': !this.showMoreButton,
      };
    },
    containerStyle() {
      const height = this.expanded || !this.showMoreButton ? this.originalHeight : this.collapseHeight;

      return {
        height: `${height}px`,
      };
    },
    showMoreButton() {
      return this.originalHeight >= this.collapseHeight;
    },
  },
  async mounted() {
    await this.$nextTick();
    this.calculateOriginalHeight();
  },
  methods: {
    async toggleExpanded() {
      this.calculateOriginalHeight();
      await this.$nextTick();
      this.expanded = !this.expanded;
    },
    calculateOriginalHeight() {
      const { slotWrapper } = this.$refs;

      if (slotWrapper) {
        const { height } = slotWrapper.getBoundingClientRect();

        this.originalHeight = height;
      }
    },
  },
};
</script>
